export const GaPush = (pageName, title) => {

    if (window.ga === undefined) return;

    // SEND GA PAGEVIEW
    window.ga('gtm1.send', 'pageview', {
        page: pageName,
        title: title
    });
}

export const getUtmString = () => {
    const utmC = getCookie("wvph_utm_campaign");
    const utmM = getCookie("wvph_utm_medium");
    const utmS = getCookie("wvph_utm_source");
    const utmCon = getCookie("wvph_utm_content");
    const utmT = getCookie("wvph_utm_term");

    const utmC_url = getURLParameter("utm_campaign");
    const utmM_url = getURLParameter("utm_medium");
    const utmS_url = getURLParameter("utm_source");
    const utmCon_url = getURLParameter("utm_content");
    const utmT_url = getURLParameter("utm_term");

    let utmCode = "";

    // UTM Campaign
    if (utmC.getValue()) {
        utmCode += "utm_campaign:=" + utmC.getValue() + "|";
    }
    else if (utmC_url) {
        utmCode += "utm_campaign:=" + utmC + "|";
    }

    // UTM Medium
    if (utmM.getValue()) {
        utmCode += "utm_medium:=" + utmM.getValue() + "|";
    }
    else if (utmM_url) {
        utmCode += "utm_medium:=" + utmM + "|";
    }

    // UTM Source
    if (utmS.getValue()) {
        utmCode += "utm_source:=" + utmS.getValue() + "|";
    }
    else if (utmS_url) {
        utmCode += "utm_source:=" + utmS + "|";
    }

    // UTM Term
    if (utmT.getValue()) {
        utmCode += "utm_term:=" + utmT.getValue() + "|";
    }
    else if (utmT_url) {
        utmCode += "utm_term:=" + utmT + "|";
    }

    // UTM Content
    if (utmCon.getValue()) {
        utmCode += "utm_content:=" + utmCon.getValue() + "|";
    }
    else if (utmCon_url) {
        utmCode += "utm_content:=" + utmCon + "|";
    }


    return utmCode.substring("|", utmCode.length - 1);
};

function getURLParameter(param){
    var pageURL = window.location.search.substring(1); //get the query string parameters without the "?"
    var URLVariables = pageURL.split('&'); //break the parameters and values attached together to an array
    for (var i = 0; i < URLVariables.length; i++) {
        var parameterName = URLVariables[i].split('='); //break the parameters from the values
        if (parameterName[0] == param) {
            return parameterName[1];
        }
    }
    return null;
}	

const getCookie = cname => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    var cookieValue = "";

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
            cookieValue = c.substring(name.length, c.length);
        }
    }

    const getValue = () => {
        if (cookieValue) {
            let value = cookieValue.split("|");
            return value[value.length - 1];
        }

        return null;
    };

    return { getValue };
};

function getGAClientID() {
    let trackers = window.ga.getAll();
    let i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
        if (trackers[i].get('trackingId') === 'UA-19748216-1' || trackers[i].get('trackingId') === 'UA-19748216-4') {
            let clientid = trackers[i].get('clientId');
            return clientid;
        }
    }

    return null;
}

export const getGaCid = () => {
    let gaClientId = "";

    if (window.ga !== undefined) {
        if (!window.sessionStorage.getItem("wv_ga_client_id")) {

            if (window.ga) {
                if (typeof window.ga.getAll === "function") {
                    gaClientId = getGAClientID();

                    if (gaClientId) {
                        window.sessionStorage.removeItem("wv_ga_client_id");
                        window.sessionStorage.setItem("wv_ga_client_id", gaClientId);
                    }
                }
            }
            
        } else {
            gaClientId = window.sessionStorage.getItem("wv_ga_client_id");
        }
    }

    return gaClientId;
};
